import { useMemo } from 'react'
import { Button, Col, List, Modal, Row, Skeleton } from 'components/common'
import { CustomizedModalProps } from './types'
import { Customer, CustomersQuery } from 'lib/graphql/storeadmin'
import { staticCustomerType } from 'lib/constants'

export interface CustomerSelectModalProps
  extends Omit<CustomizedModalProps, 'onOk'> {
  customerType?: string
  data?: CustomersQuery
  loading: boolean
  onClose: (visible: boolean) => void
  onSelect: (value: Customer) => void
}

export const CustomerSelectModal = ({
  customerType,
  data,
  loading,
  visible,
  onClose,
  onSelect,
}: CustomerSelectModalProps): JSX.Element => {
  const customerList = useMemo((): JSX.Element => {
    if (loading) return <Skeleton />
    else if (!data) return <div>該当するお客様は存在しません</div>
    else {
      return (
        <List
          loading={loading}
          dataSource={data?.customers?.edges}
          header={
            data?.customers?.edges?.length > 0 && (
              <Row>
                {customerType === staticCustomerType.corporate && (
                  <Col span={12}>法人団体名</Col>
                )}
                <Col span={12}>顧客名</Col>
              </Row>
            )
          }
          renderItem={({ customer }) => (
            <List.Item
              key={customer.id}
              actions={[
                <Button
                  onClick={() => {
                    // eslint-disable-next-line
                    // @ts-ignore
                    onSelect(customer)
                    onClose(false)
                  }}
                >
                  選択
                </Button>,
              ]}
            >
              <Row>
                {customer.type === staticCustomerType.corporate && (
                  <div style={{ width: 230 }}>{customer.corporationName}</div>
                )}
                <div>{`${customer.lastName} ${customer.firstName}`}</div>
              </Row>
            </List.Item>
          )}
        />
      )
    }
  }, [data, loading, customerType, onClose, onSelect])

  return (
    <Modal
      visible={visible}
      title={'検索の結果'}
      onCancel={() => onClose(false)}
      footer={[<Button onClick={() => onClose(false)}>閉じる</Button>]}
      bodyStyle={{ maxHeight: '500px', overflowY: 'auto' }}
    >
      {customerList}
    </Modal>
  )
}
